import AdminLayout from '@/pages/admin/components/AdminLayout';

interface PlaceholderPageProps {
  title: string;
  icon: string;
}

const PlaceholderPage = ({ title, icon }: PlaceholderPageProps) => (
  <AdminLayout title={title}>
    <div className="flex flex-col items-center justify-center h-96 text-center">
      <div className="w-20 h-20 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
        <i className={`${icon} text-4xl text-gray-300`} />
      </div>
      <p className="text-gray-500 font-medium text-base mb-1">{title}</p>
      <p className="text-gray-400 text-sm">功能开发中，敬请期待</p>
    </div>
  </AdminLayout>
);

export default PlaceholderPage;
